module.exports = __webpack_public_path__ + "static/media/bang.d475be0c.svg";